import { render, staticRenderFns } from "./PromotionDeadlinesTable.vue?vue&type=template&id=2cbae676"
import script from "./PromotionDeadlinesTable.vue?vue&type=script&lang=js"
export * from "./PromotionDeadlinesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports